<template>
  <div class="counter">
    <yt-button-icon
      color="gray"
      icon="minus"
      class="u-flex-shrink-0"
      :disabled="disabledDecrement"
      @click="decrement"
    />
    <div class="counter__value font-regular u-flex-shrink-0">
      <slot name="value" :value="value">
        {{ value }}
      </slot>
    </div>
    <yt-button-icon
      color="gray"
      icon="plus"
      class="u-flex-shrink-0"
      :disabled="disabledIncrement"
      @click="increment"
    />
  </div>
</template>

<script>
import YtButtonIcon from "@/components/ui-kit/yt-button-icon/index.vue";

export default {
  components: {
    YtButtonIcon,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
    boundsStringified() {
      return `${this.min}${this.max}`;
    },
    disabledDecrement() {
      return this.disabled || this.value - this.step < this.min;
    },
    disabledIncrement() {
      return this.disabled || this.value + this.step > this.max;
    },
  },
  watch: {
    boundsStringified: {
      handler() {
        this.$nextTick(() => {
          this.value = Math.min(Math.max(this.value, this.min), this.max);
        });
      },
      immediate: true,
    },
  },
  methods: {
    decrement() {
      if (this.disabledDecrement) {
        return;
      }

      this.value -= this.step;
      this.$emit("decrement", this.value-this.step);
    },
    increment() {
      if (this.disabledIncrement) {
        return;
      }

      this.value += this.step;
      this.$emit("increment", this.value+this.step);
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".counter";

#{$b} {
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  &__value {
    min-width: 32px;
    text-align: center;
  }
}
</style>
